// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u0O-_","content":"styles_content__32WHk","row":"styles_row__mcCpQ","footer":"styles_footer__put3A","phraseLength":"styles_phraseLength__3gcvo"};